import { render, staticRenderFns } from "./LimitExceeded.vue?vue&type=template&id=1460b36c"
import script from "./LimitExceeded.vue?vue&type=script&lang=js"
export * from "./LimitExceeded.vue?vue&type=script&lang=js"
import style0 from "./LimitExceeded.vue?vue&type=style&index=0&id=1460b36c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports